var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45084 11.5693H6.47055V12.5891H5.45084V11.5693Z",
    fill: "#C733FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3916 12.5889H3.41132V13.6086H2.3916V12.5889Z",
    fill: "#C733FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3916 11.5693H3.41132V12.5891H2.3916V11.5693Z",
    fill: "#C733FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3916 10.5498H3.41132V11.5695H2.3916V10.5498Z",
    fill: "#C733FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41147 12.5889H4.43119V13.6086H3.41147V12.5889Z",
    fill: "#C733FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50977 12.5889H9.52948V13.6086H8.50977V12.5889Z",
    fill: "#C733FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49023 12.5889H8.50995V13.6086H7.49023V12.5889Z",
    fill: "#C733FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52963 12.5889H10.5494V13.6086H9.52963V12.5889Z",
    fill: "#C733FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52963 7.49121H10.5494V8.51093H9.52963V7.49121Z",
    fill: "#C733FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5492 6.47168H11.5689V7.4914H10.5492V6.47168Z",
    fill: "#C733FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.569 5.45117H12.5887V6.47089H11.569V5.45117Z",
    fill: "#C733FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5885 4.43066H13.6082V5.45038H12.5885V4.43066Z",
    fill: "#C733FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5492 4.43066H11.5689V5.45038H10.5492V4.43066Z",
    fill: "#C733FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52963 3.41113H10.5494V4.43085H9.52963V3.41113Z",
    fill: "#C733FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5885 3.41113H13.6082V4.43085H12.5885V3.41113Z",
    fill: "#C733FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.569 2.3916H12.5887V3.41132H11.569V2.3916Z",
    fill: "#C733FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5492 2.3916H11.5689V3.41132H10.5492V2.3916Z",
    fill: "#C733FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5492 12.5889H11.5689V13.6086H10.5492V12.5889Z",
    fill: "#C733FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.569 12.5889H12.5887V13.6086H11.569V12.5889Z",
    fill: "#C733FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5885 12.5889H13.6082V13.6086H12.5885V12.5889Z",
    fill: "#C733FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45084 7.49121H6.47055V8.51093H5.45084V7.49121Z",
    fill: "#C733FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.431 12.5889H5.45072V13.6086H4.431V12.5889Z",
    fill: "#C733FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.431 10.5498H5.45072V11.5695H4.431V10.5498Z",
    fill: "#C733FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4375 9.52246H7.64398V10.5589H4.4375V9.52246Z",
    fill: "#C733FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79361 10.3975H7.28754V11.5635H4.79361V10.3975Z",
    fill: "#C733FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31186 8.71387H8.51834V9.7503H5.31186V8.71387Z",
    fill: "#C733FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44141 8.38965H8.64788V9.42609H5.44141V8.38965Z",
    fill: "#C733FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8623 7.96777H9.52222V9.00421H5.8623V7.96777Z",
    fill: "#C733FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47787 7.48145H9.71674V8.51788H6.47787V7.48145Z",
    fill: "#C733FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38052 7.48145H9.61939V8.51788H6.38052V7.48145Z",
    fill: "#C733FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48178 6.34863H10.5587V7.8709H7.48178V6.34863Z",
    fill: "#C733FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32422 5.44141H11.6279V6.47784H8.32422V5.44141Z",
    fill: "#C733FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77734 4.4375H11.1093V5.44155H8.77734V4.4375Z",
    fill: "#C733FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47037 10.5498H7.49009V11.5695H6.47037V10.5498Z",
    fill: "#C733FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47037 6.47168H7.49009V7.4914H6.47037V6.47168Z",
    fill: "#C733FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49023 9.53027H8.50995V10.55H7.49023V9.53027Z",
    fill: "#C733FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50977 8.51074H9.52948V9.53046H8.50977V8.51074Z",
    fill: "#C733FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49023 5.45117H8.50995V6.47089H7.49023V5.45117Z",
    fill: "#C733FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50977 4.43066H9.52948V5.45038H8.50977V4.43066Z",
    fill: "#C733FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41147 9.53027H4.43119V10.55H3.41147V9.53027Z",
    fill: "#C733FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M4.431 8.51074H5.45072V9.53046H4.431V8.51074Z",
    fill: "#C733FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeCard);
export default __webpack_public_path__ + "static/media/change_card.b06d68f0da071ddcfc28eda3838bacd8.svg";
export { ForwardRef as ReactComponent };